module.exports = __webpack_public_path__ + "static/media/google-chrome.9c8979a4.png";